import { useRef, useState } from 'react';
import { FileVideo } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { FILE_ACCEPT } from '@/constants/media';
import { openVideoFile } from '@/features/project/projectActions';

/** Header action: swap the source video without losing tuned settings. */
export function ReplaceVideoButton() {
  const inputRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={FILE_ACCEPT}
        className="sr-only"
        aria-hidden
        tabIndex={-1}
        onChange={async (event) => {
          const file = event.target.files?.[0];
          event.target.value = '';
          if (!file) return;
          setBusy(true);
          try {
            await openVideoFile(file);
          } finally {
            setBusy(false);
          }
        }}
      />
      <Button
        variant="secondary"
        size="sm"
        loading={busy}
        onClick={() => inputRef.current?.click()}
      >
        {!busy && <FileVideo aria-hidden className="size-4" />}
        <span className="hidden sm:inline">Replace video</span>
        <span className="sm:hidden">Replace</span>
      </Button>
    </>
  );
}
